import { render, staticRenderFns } from "./ModelOverall.vue?vue&type=template&id=66120135"
import script from "./ModelOverall.vue?vue&type=script&lang=ts"
export * from "./ModelOverall.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports